import React, { ComponentProps } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ImageTransformType, ImageType } from '../../modules/image/constants';
import { Image } from '../../modules/image/image';
import { SeriesNumber } from '../series-number/series-number';
import { Typography } from '../typography/typography';
import { notNil } from '../../core/helpers/is-nil';
import { useKnowsHowToUse3dViewer } from '../../modules/article-preview/use-knows-how-to-use-3d-viewer';
import styles from './page-header-article-information.module.scss';

type Props = {
  seriesName: React.ReactNode;
  productTitle: string;
  itemDesc2: string;
  itemDesc3: string;
  pictoSrc: string | undefined;
  moveOut?: boolean;
} & ComponentProps<typeof SeriesNumber>;

export const PageHeaderArticleInformation: React.FC<Props> = ({
  productTitle,
  seriesName,
  itemDesc2,
  itemDesc3,
  pictoSrc,
  seriesNumber,
  seriesNumberColor,
  moveOut = false,
}) => {
  const { t } = useTranslation();
  const { knowsHowToUse3DViewer } = useKnowsHowToUse3dViewer();
  return (
    <div
      className={classNames(styles.root, {
        [styles.moveOut]: moveOut,
      })}
    >
      <div className={styles.topContainer}>
        <div className={styles.seriesInfo}>
          <div className={styles.categoryContainer}>
            {notNil(pictoSrc) ? (
              <div className={styles.picto}>
                <Image baseSrc={pictoSrc} imageSizes={ImageTransformType.picto} type={ImageType.aspectRatio} />
              </div>
            ) : null}
            <SeriesNumber seriesNumber={seriesNumber} seriesNumberColor={seriesNumberColor} variant="pageHeader" />
          </div>
          <Typography color="white" fontStyle="bold" variant="smalltext">
            {seriesName}
          </Typography>
        </div>
        <div className={styles.textContainer}>
          <Typography color="white" variant="headline-2">
            {productTitle}
          </Typography>
          <div className={styles.lowerContainer}>
            <Typography color="white" variant="headline-3">
              {itemDesc2}
            </Typography>
            <Typography color="white" variant="maintext">
              {itemDesc3}
            </Typography>
          </div>
        </div>
      </div>
      <div
        className={classNames(styles.instructionContainer, {
          [styles.show]: moveOut && !knowsHowToUse3DViewer,
        })}
      >
        <Typography variant="maintext">{t('articleDetail.3d.interactionInstruction')}</Typography>
      </div>
    </div>
  );
};
